  import React, { useState } from "react";
  import { useLocation, useNavigate } from "react-router-dom";
  import { accountApi } from '../../api/account';
  import "styles/ResetPassword.scss";

  const ResetPassword = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");

    const token = new URLSearchParams(location.search).get("token");

    // Password validation function
  const validatePassword = (password) => {
          const hasUpperCase = /[A-Z]/.test(password);
          const hasLowerCase = /[a-z]/.test(password);
          const hasNumbers = /\d/.test(password);
          const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
          const hasMinLength = password.length >= 8;

          if (!hasMinLength) {
              return 'Password must be at least 8 characters long';
          }
          if (!hasUpperCase) {
              return 'Password must contain at least one uppercase letter';
          }
          if (!hasLowerCase) {
              return 'Password must contain at least one lowercase letter';
          }
          if (!hasNumbers) {
              return 'Password must contain at least one number';
          }
          if (!hasSpecialChar) {
              return 'Password must contain at least one special character';
          }
          return '';
      };


    const handleSubmit = async (e) => {
      e.preventDefault();
      setError("");
      setMessage("");

      // Validate password strength
      const passwordError = validatePassword(newPassword);
      if (passwordError) {
        setError(`Password error: ${passwordError}`);
        return;
      }

      // Confirm passwords match
      if (newPassword !== confirmPassword) {
        setError("Passwords do not match");
        return;
      }

      try {
        setLoading(true);
        const response = await accountApi.resetPassword({ token, newPassword });
          if (response?.status) {
          setMessage(response.message || "Password reset successful");
        navigate("/");
        } else {
          setError(response?.message || "Something went wrong");
        }
      } catch {
        setError("Invalid or expired reset link. Try again.");
      } finally {
        setLoading(false);
      }
    };

    return (
      <div className="reset-container">
        <div className="reset-content">
          <div className="reset-left">
            <div className="reset-subtitle">
              <h2>Reset Password</h2>
              <p>Enter your new password below</p>
            </div>
            <form className={`reset-form ${loading ? "form-loading" : ""}`} onSubmit={handleSubmit}>
              {error && <div className="general-error">{error}</div>}
              {message && <div className="general-success">{message}</div>}
              <div className="form-group">
                <input
                  type="password"
                  placeholder="New Password"
                  className="reset-input"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                  disabled={loading}
                />
              </div>
              <div className="form-group">
                <input
                  type="password"
                  placeholder="Confirm Password"
                  className="reset-input"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                  disabled={loading}
                />
              </div>
              <button type="submit" className="reset-btn" disabled={loading}>
                {loading ? "Resetting..." : "Submit"}
              </button>
              <div className="login-link">
                <button type="button" className="login-back-btn" onClick={() => navigate("/login")}>
                  Back to Login
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  };

  export default ResetPassword;
